<!-- {{'ROOT.SHARED.SHARED_TEXT'|translate}}

{{'ROOT.ROOT_TEXT'|translate}}

{{'ROOT.SHARED.UILM.APP'|translate}} -->

<fuse-main [navigations]="navigations" [appList]="apps" [toolbarComponent]="toolbarComponent" id="am-1354"></fuse-main>
<app-pcx-snackbar></app-pcx-snackbar>
<p-toast position="bottom-right" key="toast-665524a6-0b9d-4079-816f-4fc4fecf0fea" />